import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { fetchAllModules } from '../../requests/learning';
import Carousel from './TrainingCarousel';
import LoadingContent from 'lqa-ui/lib/Components/LoadingContent';
import { AppHeader } from '../../app/common/sharedComponents/AppHeader';
import { useTranslation } from 'react-i18next';

const Wrapper = styled.div``;

const Cards = styled.div`
  margin-bottom: 88px;
  margin-top: 88px;
  padding: 16px;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 25px;
`;

const LQATraining = () => {
  const { t } = useTranslation();
  const [modules, setModules] = useState<any>(undefined);
  useEffect(() => {
    (async () => {
      const data = await fetchAllModules();
      const filteredData = data.filter(
        (module: { name: string }) => module.name !== 'Emotional Intelligence'
      );
      setModules(filteredData);
    })();
  }, []);

  return (
    <Wrapper>
      <div className="header">
      <AppHeader title={t('COMMON.LEARNING.TITLES.LQA_TRAINING')} hasBackButton={true} />
      </div>
      <Cards>
        <Content>
          {!modules ? (
            <LoadingContent layout="flex" />
          ) : (
            modules.map((module) => (
              <Carousel
                key={module.id}
                data={module}
                cardNavigatePath="/learning/watch-video"
              />
            ))
          )}
        </Content>
      </Cards>
    </Wrapper>
  );
};

export default LQATraining;
